import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { GetRemoteRole, RemoteSignout } from 'contexts/session'
import { getSignInType, signOut } from '../'

interface GetRemoteRoleProps {
  enabled?: boolean
  timeout: number
}

const QUERY_KEY = {
  SESSION_ROLE: 'session-role',
  SESSION_SIGNOUT: 'session-signout',
}

export const useRemoteSignout: RemoteSignout = () => {
  const queryClient = useQueryClient()

  const { mutateAsync } = useMutation({
    mutationKey: [QUERY_KEY.SESSION_SIGNOUT],
    mutationFn: signOut,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY.SESSION_ROLE] })
    },
  })

  return () => mutateAsync()
}

export const useGetRemoteRole: GetRemoteRole = ({ enabled, timeout }: GetRemoteRoleProps) => {
  return useQuery({
    queryKey: [QUERY_KEY.SESSION_ROLE],
    queryFn: () => getSignInType({ timeout, disableCustomErrorHandler: true }),
    retry: false,
    enabled,
  })
}
